import { Edit, SimpleForm } from "@/components/admin";
import { TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UrlTabs } from "@/components/ui/url-tabs";
import { InheritedFieldset } from "@/components/inheritance/InheritedFieldset";
import { PublishingFields } from "@/components/inheritance/PublishingFields";
import { DetailsTab } from "./tabs/details-tab";
import { RbacTab } from "./tabs/rbac-tab";
import { ScopesTab } from "./tabs/scopes-tab";
import { RawJsonTab } from "@/common/RawJsonTab";

export function ResourceServerEdit() {
  return (
    <Edit mutationMode="pessimistic">
      <SimpleForm className="max-w-none">
        <UrlTabs defaultValue="details" className="w-full">
          <TabsList>
            <TabsTrigger value="details">Details</TabsTrigger>
            <TabsTrigger value="rbac">RBAC</TabsTrigger>
            <TabsTrigger value="scopes">Scopes</TabsTrigger>
            <TabsTrigger value="raw">Raw JSON</TabsTrigger>
          </TabsList>
          <TabsContent value="details" className="mt-4">
            <InheritedFieldset>
              <DetailsTab />
              <PublishingFields />
            </InheritedFieldset>
          </TabsContent>
          <TabsContent value="rbac" className="mt-4">
            <RbacTab />
          </TabsContent>
          <TabsContent value="scopes" className="mt-4">
            <ScopesTab />
          </TabsContent>
          <TabsContent value="raw" className="mt-4">
            <RawJsonTab />
          </TabsContent>
        </UrlTabs>
      </SimpleForm>
    </Edit>
  );
}
